import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PlansService } from "../../services/plans.service";
import { PracticeModel, PracticesDirectoryRequest } from "../../models/plans.model"
import { HttpError } from 'src/app/core/http';
import { environment } from 'src/environments/environment';
import { EventsManager } from 'src/app/events/events.manager';
import { GoogleMap, GoogleMapsModule, MapAdvancedMarker, MapInfoWindow } from "@angular/google-maps";
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { PhonePipe } from '../../pipes/phone.pipe';
import { LocationCardComponent } from './location-card/location-card.component';
import { NgIf, NgFor } from '@angular/common';
import {ActivatedRoute} from "@angular/router";



@Component({
    selector: 'app-find-a-dentist',
    templateUrl: './find-a-dentist.component.html',
    styleUrl: './find-a-dentist.component.scss',
    standalone: true,
    imports: [NgIf, NgFor, LocationCardComponent, GoogleMap, MapAdvancedMarker, MapInfoWindow, PhonePipe]
})
export class FindADentistComponent implements OnInit, AfterViewInit {
  @ViewChild('searchBox') searchBox!: ElementRef;
  @ViewChild(GoogleMap, { static: false }) mapContainer!: GoogleMap;
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;

  markers: Array<{ position: google.maps.LatLngLiteral; label: string; practice: PracticeModel, content: any }> = [];
  infoContent: string = '';
  iconColor: string = '#FDB936';

  showResults: boolean = false;
  autocomplete!: google.maps.places.Autocomplete;
  originalPractices!: PracticeModel[];
  filteredPractices!: PracticeModel[];

  center: google.maps.LatLngLiteral = { lat: 39.4515876, lng: -97.1658519 };
  zoom = 5;
  mapId: string = environment.googleMapId;
  mapOptions: google.maps.MapOptions = {
    mapId: this.mapId,
    zoomControl: true, // Enable zoom controls
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM, // Position of zoom controls (customizable)
    },
    maxZoom: 18,
    disableDefaultUI: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    streetViewControl: false,
  };
  map!: google.maps.Map;

  constructor(private plansService: PlansService, private em: EventsManager, private googleAnalyticsService: GoogleAnalyticsService,private route:ActivatedRoute) {}

  ngOnInit() {
    this.initializeAddress();

    this.em.planDataUpdated.subscribe(
      (data:string) => {
        this.getDirectory(data);
      })

    const url: string = this.route.snapshot.url.join('|');
    
    if(url.includes('adha')) {
      this.em.purchaseIsADHA = true;
      this.em.setHideHeader(true);
    }
  }

  ngAfterViewInit(): void {
    window.scroll(0,-window.scrollY);
    this.map = this.mapContainer.googleMap!;
    this.addBoundsChangeListener();
    this.initializeAutocomplete();
    //this.zoomToUserLocation();

    const mapContainer = document.querySelector('#mapContainerDiv');
    if (mapContainer) {
      if (mapContainer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              const infoWindowContent = mapContainer.querySelector('.gm-style-iw-d');
              if (infoWindowContent) {
                // Apply custom styles
                (infoWindowContent as HTMLElement).style.overflow = 'hidden !important';

                // Stop observing once the element is found and styled
                observer.disconnect();
              }
            }
          });
        });

        // Start observing the map container for child elements
        observer.observe(mapContainer, {
          childList: true,
          subtree: true
        });
      }
    }

  }

  addBoundsChangeListener() {
    if (this.map) {
      this.map.addListener('bounds_changed', () => {
        this.onBoundsChanged();
      });
    }
  }

  removeBoundsChangeListener() {
    if (this.map) {
      this.map.addListener('bounds_changed', () => {
      });
    }
  }

  initializeAddress(): void {
    let planeName:string = "";
    if (this.em && this.em.planName != '') {
      planeName = this.em.planName;
    }

    this.getDirectory(planeName);
  }

  initializeAutocomplete() {

    this.autocomplete = new google.maps.places.Autocomplete(
      this.searchBox.nativeElement,
      {
        types: ['geocode'], componentRestrictions: { country: 'us' }
      });

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      if (place.geometry) {
        const location = place.geometry.location!;
        this.map.setCenter(location);
        this.map.setZoom(10);
      }
    });
  }

  getDirectory(name:string){
    const request: PracticesDirectoryRequest = {
      planName: name
    };
    this.plansService.getPracticesDirectory(request).subscribe((result) => {
      if (!(result instanceof HttpError)) {
        this.originalPractices = result.entries;
        this.onBoundsChanged();
      }
    });
  }

  findLocations() {

    if (this.autocomplete.getPlace()) {
      this.onBoundsChanged();
    }
  }

  getTheUSAddress(results:any):any {
    for(var i = 0; i < results.length; i++) {
      if (results[i].address_components[results[i].address_components.length - 1].short_name == 'US') {
        return results[i];
      }
    }

    return results[0];
  }

  trackByMarker(index: number, marker: any): string {

    return marker.practice.id;
  }

  clearMarkers() {

    this.showResults = false;
    this.filteredPractices = [];
    this.markers = [];
  }

  createMarkers() {

    if (!this.filteredPractices || this.filteredPractices.length === 0) {
      return
    };

    this.markers = []; // Clear existing markers
    this.filteredPractices.forEach((practice, index) => {
      this.markers.push({
        position: { lat: practice.latitude!, lng: practice.longitude! }, // Make sure latitude and longitude are defined
        label: `${index + 1}`,
        practice,
        content: this.getMarkerContent(index)
      });
    });
    this.showResults = true;

  }

  onMarkerClick(advancedMarker: MapAdvancedMarker, marker: { position: google.maps.LatLngLiteral; practice: PracticeModel, content: any }) {
    if (this.infoWindow.infoWindow!.isOpen) {
      this.infoWindow.close();
    }
    this.infoContent = this.getInfoWindowContent(marker.practice);

    this.infoWindow.openAdvancedMarkerElement(advancedMarker.advancedMarker, this.infoContent);
    // @ts-ignore
    let elem:number = document.getElementById('marker' + marker.label).offsetTop;
    // @ts-ignore
    let cont:number = document.getElementById('dentist-listings').offsetTop;
    // @ts-ignore
    document.getElementById('dentist-listings').scrollTo({top:elem-cont, behavior: 'smooth'});
  }

  getInfoWindowContent(practice: PracticeModel): string {
    var site = '';
    if (practice.url) {
      site = `
      <br/><br/>
      <a href="${practice.url}" target=_blank>
        <i class="bi bi-link-45deg icon" style="margin-right: 5px;"></i>Website
      </a>`;
    }

    const phone = this.formatToPhoneNumber(practice.phone);

    const addressFull =
      practice.address.line1 +
      (practice.address.line2 ? ' ' + practice.address.line2 : '') +
      '<br />' +
      practice.address.city +
      ', ' +
      practice.address.state +
      ' ' +
      practice.address.zipCode;

    const infoWindowContent = `
        <div style="font-weight: bold; font-size: 1.2rem;color: #5a3ec8;"> ${practice.title}</div>
        <div style="font-size: 14px;">${addressFull}</div><hr>
        <div style="color: #5a3ec8; font-size: 14px;">
            <a href='tel:${practice.phone}'>${phone}</a>
            <a href="http://maps.google.com/?q=${addressFull.replace('<br />', ', ')}" style="padding-left:10px;" target=_blank>
                <i class="bi bi-geo-alt icon" style="margin-right: 5px;"></i>Get Directions
            </a>
          ${site}
        </div>
      `;
    return infoWindowContent;
  }

  formatToPhoneNumber(value: string): string {
    // Remove any non-digit characters
    const cleaned = value.replace(/\D/g, '');

    // Check if the cleaned number has exactly 10 digits
    if (cleaned.length !== 10) {
      return "Invalid phone number";
    }

    // Format the phone number
    const formattedPhoneNumber = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    return formattedPhoneNumber;
  }

  getRandomUuId(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); return v.toString(16); });
  }

  getMarkerContent(index: number): any {
    const iconNumber = index + 1;
    const markerElement = document.createElement('div');
    markerElement.classList.add('drop-animation');
    markerElement.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="45px" height="63px" viewBox="0 0 39 54">
        <g fill="${this.iconColor}" fill-rule="evenodd">
          <g transform="translate(-805.000000, -662.000000)">
            <g transform="translate(805.000000, 662.000000)">
              <g>
                <g transform="translate(10.000000, 10.000000)" fill="white" stroke="%23979797">
                  <circle cx="9.5" cy="9.5" r="9.5"/>
                </g>
                <g fill="${this.iconColor}" text-anchor="middle" fill-rule="nonzero">
                  <path d="M28.7368421,19.7307692 C28.7368421,24.8906788 24.60136,29.0769231 19.5,29.0769231 C14.3979138,29.0769231 10.2631579,24.8906788 10.2631579,19.7307692 C10.2631579,14.5693833 14.39864,10.3846154 19.5,10.3846154 C24.6024493,10.3842463 28.7368421,14.5690142 28.7368421,19.7307692 M39,19.6364694 C39,8.79133788 30.2700926,0 19.5,0 C8.73067398,0 0,8.79133788 0,19.6364694 C0,24.4047446 1.68948641,28.7767622 4.49699275,32.1775218 L19.5168642,54 L34.7563536,31.8591974 C35.3036736,31.1694298 35.8050003,30.4424404 36.2572675,29.6782291 L36.411345,29.4556734 L36.3860487,29.4556734 C38.0456395,26.5655511 39,23.2148083 39,19.6364694"/>
                </g>
                <text x="19.1" y="24" font-family="Sans-Serif" font-size="12" font-weight="bold" fill="${this.iconColor}" text-anchor="middle">${iconNumber}</text>
              </g>
            </g>
          </g>
        </g>
      </svg>`;
    return markerElement;
  }

  onBoundsChanged() {
    const bounds = this.mapContainer.googleMap!.getBounds();
    if (bounds && this.originalPractices && this.originalPractices.length > 0) {
      this.clearMarkers();
      const zoomLevel = this.map.getZoom();
      if (zoomLevel && zoomLevel >= 10) {
        this.originalPractices.forEach(practice => {
          if (this.map.getBounds() &&
            this.map.getBounds()!.contains({
              lat: practice.latitude!,
              lng: practice.longitude!
            })
          ) {
            this.filteredPractices.push(practice);
          }
        });
        this.createMarkers();
      }
    }
  }

  easeInOutQuad(t:any, b:any, c:any, d:any) {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
  }
  zoomToUserLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.map.setCenter(userLocation);
        this.map.setZoom(10);
      });
    }
  }

  clickDentistWebsite() {
    this.googleAnalyticsService.sendKeyEvent('click_dentist_website', {
      timestamp: new Date().toISOString()
    });
  }
}
